import { isLocal } from '../../localId/localId';
import {
  ADD_LOCAL_MATERIAL,
  API_CREATE_MATERIAL,
  API_REMOVE_MATERIAL,
  API_UPDATE_MATERIAL,
  dirtyMaterials,
  MATERIAL_SET_ERROR,
  MATERIAL_UNSET_ERRORS,
  REMOVE_LOCAL_MATERIAL,
  SAVE_MATERIAL,
} from './material.reducer';

export const unsetErrors = () => ({ type: MATERIAL_UNSET_ERRORS });
export const setError = () => ({ type: MATERIAL_SET_ERROR });
export const save = resource => ({ type: SAVE_MATERIAL, resource });
export const add = workOrderId => ({ type: ADD_LOCAL_MATERIAL, workOrderId });
export const remove = id => ((isLocal(id))
  ? ({ type: REMOVE_LOCAL_MATERIAL, id })
  : ({ resourceAction: API_REMOVE_MATERIAL, id }));

export const apiSaveDirty = () =>
  (dispatch, getState) =>
    Promise.all(dirtyMaterials(getState()).map(resource =>
      ((isLocal(resource.id))
        ? dispatch({ resourceAction: API_CREATE_MATERIAL, resource })
        : dispatch({ resourceAction: API_UPDATE_MATERIAL, resource }))));



// WEBPACK FOOTER //
// ./src/reducers/workOrder/material/material.actions.js